import { differenceInMinutes, format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import "./style.scss";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsPeople } from "react-icons/bs";
import { MdWarning } from "react-icons/md";
import useGetTicketAndPasses from "../../../../utils/hooks/useGetTicketAndPasses";
import { useTranslation } from "react-i18next";
import SingleExerciseDetailsModal from "./SingleExerciseDetailsModal";
import getId from "../../../../utils/getId";
import useTicketAccess from "../hooks/useTicketAccess";
import { useSearchParams } from "react-router-dom";
import EAButton from "../../shared/Buttons/EAButton";
import EAChip from "../../shared/Chip/EAChip";

interface IProps {
  exercise: Exercise;
  onRefreshExercises: () => void;
}

const SingleExercise: React.FC<IProps> = ({ exercise, onRefreshExercises }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [, setOpenModalTicket] = useState(false);
  const { ticketAccess, getTicketAccess } = useTicketAccess();
  const { getTicketsByExercise, tickets } = useGetTicketAndPasses();

  const handleModals = (value: string) => {
    if (value === "exerciseInfoModal") {
      setOpen(true);
      setOpenModalTicket(false);
    }
    if (value === "ticketsModal") {
      setOpenModalTicket(true);
      setOpen(false);
    }
  };

  useEffect(() => {
    const exerciseId = searchParams.get("exerciseId");
    if (exerciseId && getId(exercise) === exerciseId) {
      handleModals("exerciseInfoModal");
      getTicketsByExercise(exercise.exerciseGroup.objectId);
      updateTicketAccess();
    }
    //eslint-disable-next-line
  }, [searchParams, exercise]);

  const handleClose = () => {
    setOpen(false);
    const currentParams = Object.fromEntries(searchParams.entries());
    const { exerciseId, ...restParams } = currentParams;
    setSearchParams(restParams);
  };

  const handleOpenExerciseModal = () => {
    handleModals("exerciseInfoModal");
    getTicketsByExercise(exercise.exerciseGroup.objectId);
    updateTicketAccess();
    const currentParams = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...currentParams, exerciseId: getId(exercise) });
  };

  const updateTicketAccess = () => {
    getTicketAccess(exercise);
  };

  const isPast = exercise.startTime < Date.now();
  const isInactive = exercise.status !== "A" || isPast;
  const accentColor = exercise.buttonCollor;
  const durationMinutes =
    exercise.startTime && exercise.closeTime
      ? differenceInMinutes(exercise.closeTime, exercise.startTime)
      : 0;
  const instructorName = exercise.humanName || exercise.human?.displayName || "";
  const deputyName = [exercise.deputyHumanName, exercise.deputyHumanLastName].filter(Boolean).join(" ");
  const taken = exercise.reserved + exercise.prereservation;

  return (
    <>
      <div
        className={`schedule-exercise-card${isInactive ? " schedule-exercise-card--unavailable" : ""}`}
        style={accentColor ? { borderLeftColor: accentColor } : undefined}
        onClick={handleOpenExerciseModal}
      >
        <div className="schedule-exercise-card__header">
          <span className="schedule-exercise-card__time" style={accentColor ? { color: accentColor } : undefined}>
            <AiOutlineClockCircle className="schedule-exercise-card__time-icon" />
            {format(exercise.startTime, "HH:mm")}
          </span>
          <span className="schedule-exercise-card__duration">{durationMinutes} min.</span>
        </div>

        <div className="schedule-exercise-card__body">
          <strong className="schedule-exercise-card__name" dangerouslySetInnerHTML={{ __html: exercise.name }} />
          {instructorName && (
            deputyName ? (
              <span className="schedule-exercise-card__instructor">
                <MdWarning className="schedule-exercise-card__deputy-icon" />
                <s>{instructorName}</s> {deputyName}
              </span>
            ) : (
              <span className="schedule-exercise-card__instructor">{instructorName}</span>
            )
          )}
          {exercise.location && <span className="schedule-exercise-card__location">{exercise.location}</span>}
        </div>

        <div className="schedule-exercise-card__footer">
          <div className="schedule-exercise-card__footer-row">
            <span className="schedule-exercise-card__spots">
              <BsPeople className="schedule-exercise-card__spots-icon" />
              {taken}/{exercise.capacity}
            </span>
          </div>
          <div className="schedule-exercise-card__footer-row schedule-exercise-card__footer-row--action">
            {exercise.assigned && !exercise.waitList && <EAChip label={t("jestes_zapisany")} variant="success" />}
            {exercise.waitList && (
              <EAChip label={`${t("lista_rezerwowa")} (${exercise.waitListPosition})`} variant="warning" />
            )}
            {isInactive ? (
              <span className="schedule-exercise-card__unavailable-label">{t("niedostepny", "Niedostępny")}</span>
            ) : (
              <div onClick={(event) => event.stopPropagation()}>
                <EAButton title={t("sprawdz")} compact color="dark" onClick={handleOpenExerciseModal} />
              </div>
            )}
          </div>
        </div>
      </div>

      {open && (
        <SingleExerciseDetailsModal
          exercise={exercise}
          onClose={handleClose}
          ticketsListLength={tickets.length}
          handleModals={handleModals}
          onRefreshExercises={onRefreshExercises}
          tickets={tickets}
          ticketAccess={ticketAccess}
        />
      )}

      {/* {openModalTicket && (
        <SingleExerciseTicketModal
          exercise={exercise}
          onClose={() => setOpenModalTicket(false)}
          tickets={tickets}
          ticketAccess={ticketAccess}
          onBack={() => {
            setOpenModalTicket(false);
            setOpen(true);
          }}
        />
      )} */}
    </>
  );
};

export default SingleExercise;
